export const findAvailableServerPorts = (
  usedPorts: number[],
  startPort: number,
  endPort: number,
  count: number
): number[] => {
  const used = new Set(usedPorts);
  const available: number[] = [];

  for (let port = startPort; port <= endPort && available.length < count; port++) {
    if (!used.has(port)) {
      available.push(port);
    }
  }

  if (available.length !== count) {
    throw new Error(`Only ${available.length} of ${count} requested server ports are available in range ${startPort}-${endPort}`);
  }

  return available;
};
